module.exports = __webpack_public_path__ + "img/angststoerungen_1280.69aa44e7.webp";